module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['row', _vm.rowClass]
  }, [_c('div', {
    staticClass: "col-2 p-0 align-self-center",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.data[_vm.name]))]), _vm._v(" "), _c('div', {
    staticClass: "col-7 fs-90"
  }, [_c('small', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 p-0 d-flex"
  }, [_c('div', {
    class: ['align-self-stretch', _vm.tableName + '-' + _vm.name],
    style: (_vm.data[_vm.name + 'Width'])
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a00a276"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/SupplierRFQRow.vue
// module id = 693
// module chunks = 0